"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const reducers_1 = require("../../../reducers");
const AudienceLink_1 = require("../components/AudienceLink");
const FormSection_1 = require("../../utils/FormSection");
const SegmentConditionSelector_1 = require("./SegmentConditionSelector");
const SegmentSelector_1 = require("./SegmentSelector");
const DevicePredicateList_1 = require("./DevicePredicateList");
const actions_1 = require("../../../actions");
const segments_1 = require("../../../actions/segments");
const DeviceListSelector_1 = require("./DeviceListSelector");
class Audience extends React.PureComponent {
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        const { fetchAudienceSize, fetchDeviceLists, fetchDeviceTotalSize, fetchDeviceUserInfo } = this.props;
        fetchDeviceLists();
        fetchDeviceTotalSize();
        fetchDeviceUserInfo();
        fetchAudienceSize();
    }
    render() {
        const { device, currentWizard, currentPage, segment } = this.props;
        const renderSegmentationSelector = () => {
            if (!segment) {
                return;
            }
            switch (segment.__typename) {
                case 'CompoundSegment':
                    return React.createElement(SegmentSelector_1.default, { device: device });
                case 'DeviceListSegment':
                    return React.createElement(DeviceListSelector_1.default, { device: device });
                case 'DevicePredicateSegment':
                    return React.createElement(DevicePredicateList_1.default, { device: device });
                default:
                    return;
            }
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(FormSection_1.default, { device: device, style: { marginTop: 24 } },
                React.createElement(src_1.Text, { text: "Audience", size: "h1", textStyle: { marginBottom: 8 } }),
                React.createElement(SegmentConditionSelector_1.default, { device: device }),
                renderSegmentationSelector()),
            device === 'Desktop' &&
                (currentWizard === 'audience' || currentPage === 'audience') &&
                ReactDOM.createPortal(React.createElement(AudienceLink_1.default, { primaryText: "Segments are managed in the Rover Audience App", secondaryText: "Manage Segments", style: { width: 220 } }), document.getElementById('mainModalRight'))));
    }
}
const mapStateToProps = (state) => ({
    currentWizard: reducers_1.getCurrentWizard(state),
    currentPage: reducers_1.getCurrentFormPage(state),
    segment: reducers_1.getEditableCampaignSegment(state),
});
const mapDispatchToProps = (dispatch) => ({
    fetchDeviceLists: () => dispatch(actions_1.fetchDeviceLists()),
    fetchDeviceTotalSize: () => dispatch(actions_1.fetchDeviceTotalSize()),
    fetchDeviceUserInfo: () => dispatch(actions_1.fetchDeviceUserInfo()),
    fetchAudienceSize: () => dispatch(segments_1.fetchAudienceSize()),
});
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Audience);
